module.exports = __webpack_public_path__ + "img/entry-hero.89987cd9.png";